import getAudibleBook from "./get-audible-book";
import searchAudible from "./search-audible";

const audibleApi = { searchAudible, getAudibleBook };

export { searchAudible, getAudibleBook };

export default audibleApi;
